import { useTheme } from '@mui/material/styles';
import { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { generateId, invalidUrlError, validateUrl } from '../../utils/functions';

const CitationAndReferenceForm = ({
  citations,
  setCitations,
  category,
  set_current_citation,
  current_citation,
}) => {
  const theme = useTheme();
  const [title, setTitle] = useState('');
  const [venue, setVenue] = useState('');
  const [authors, setAuthors] = useState([{ authorId: generateId(), name: '', external_link: '' }]);
  const [doi, setDoi] = useState('');
  const [url, setURL] = useState('');
  const [publicationDate, setPublicationDate] = useState('');
  const [pdf_link, set_pdfLink] = useState('');
  const [selectedCitation, setSelectedCitation] = useState(null);
  const [show, setShow] = useState(true);
  const [error, setError] = useState(null);
  const formTopRef = useRef(null);

  const onSubmitForm = async (event) => {
    event.preventDefault();

    if (selectedCitation) {
      if (selectedCitation?.title === '') {
        setError('Title required');
        return;
      }

      const payload = {
        paperId: selectedCitation?.paperId,
        title: selectedCitation?.title,
        authors: selectedCitation?.authors,
        doi: selectedCitation?.doi,
        url: selectedCitation?.url,
        journel: selectedCitation?.journel,
        pdf_link: selectedCitation?.pdf_link,
        publicationDate: selectedCitation?.publicationDate,
      };

      let updated_citations = await Promise.all(
        citations.map((item) => {
          if (item?.paperId === selectedCitation.paperId) {
            return {
              ...item,
              ...payload,
            };
          } else {
            return item;
          }
        })
      );
      setCitations(updated_citations);
    } else {
      if (title === '') {
        setError('Title required');
        return;
      }

      const payload = {
        paperId: generateId(),
        title,
        authors,
        doi,
        url,
        venue,
        pdf_link,
        publicationDate,
      };

      setCitations([...citations, payload]);
    }

    setTitle('');
    setAuthors([{ authorId: generateId(), name: '', external_link: '' }]);
    setVenue('');
    setDoi('');
    setURL('');
    setPublicationDate('');
    set_pdfLink('');

    set_current_citation(null);
    setSelectedCitation(null);
    setShow(true);

    // Scroll to the top of the citation form
    if (formTopRef.current) {
      formTopRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <div ref={formTopRef} style={{ textAlign: 'left', marginBottom: '3rem' }}>
        <label className="label-style" style={{ fontSize: 20 }}>
          {category === 'citation' && 'Citations'} {category === 'reference' && 'References'}
        </label>

        {citations.map((citation, index) => (
          <div>
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 10,
                }}
              >
                <div
                  className="input-style"
                  style={{
                    cursor: 'pointer',
                    backgroundColor: '#f3f4f7',
                  }}
                  onClick={() => {
                    if (selectedCitation && citation.paperId === selectedCitation.paperId) {
                      setSelectedCitation(null);
                    } else {
                      setSelectedCitation(citation);
                    }

                    setShow(false);
                  }}
                >
                  <span className="label-style-wt-mb">{citation?.title || 'No Title'}</span>
                </div>

                <img
                  src="/delete.svg"
                  onClick={() => {
                    const updated_citations = citations.filter(
                      (_, itemIndex) => itemIndex !== index
                    );
                    setCitations(updated_citations);
                  }}
                  style={{ cursor: 'pointer' }}
                  alt="delete"
                  width={24}
                  height={24}
                />
              </div>

              {/* Show Edit Form For Current Citation */}

              {selectedCitation && selectedCitation.paperId === citation.paperId && (
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <label className="label-style">Title:</label>
                  </div>

                  <input
                    type="text"
                    className={`${citation.title.length === 0 ? 'input-error-style' : 'input-style'}`}
                    value={citation.title}
                    onChange={async (e) => {
                      const updated_citations = citations.map((item) => {
                        if (item.paperId === selectedCitation.paperId) {
                          return {
                            ...item,
                            title: e.target.value,
                          };
                        } else {
                          return item;
                        }
                      });
                      setCitations(updated_citations);
                    }}
                  />

                  <div
                    style={{
                      width: '100%',
                      marginTop: '10px',
                      marginBottom: '10px',
                    }}
                  >
                    {citation?.authors.length > 0 && (
                      <div>
                        {citation?.authors.map((data, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 4,
                              }}
                            >
                              <div style={{ width: '45%' }}>
                                <label className="label-style">Author Name</label>
                                <input
                                  type="text"
                                  className="input-style"
                                  value={data.name}
                                  onChange={async (event) => {
                                    const value = event.target.value;
                                    const update_authors = citation?.authors.map((item) => {
                                      if (item.authorId === data.authorId) {
                                        return {
                                          ...item,
                                          name: value,
                                        };
                                      } else {
                                        return item;
                                      }
                                    });
                                    const updated_citations = citations.map((item) => {
                                      if (item.paperId === selectedCitation.paperId) {
                                        return {
                                          ...item,
                                          authors: update_authors,
                                        };
                                      } else {
                                        return item;
                                      }
                                    });
                                    setCitations(updated_citations);
                                  }}
                                />
                              </div>

                              <div style={{ width: '55%' }}>
                                <label className="label-style">Author URL</label>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div style={{ width: '100%' }}>
                                    <input
                                      type="text"
                                      className="input-style"
                                      placeholder="External Link"
                                      pattern={validateUrl}
                                      title={invalidUrlError}
                                      value={data.external_link}
                                      onChange={async (event) => {
                                        const value = event.target.value;
                                        const update_authors = citation?.authors.map((item) => {
                                          if (item.authorId === data.authorId) {
                                            return {
                                              ...item,
                                              external_link: value,
                                            };
                                          } else {
                                            return item;
                                          }
                                        });

                                        const updated_citations = citations.map((item) => {
                                          if (item.paperId === selectedCitation.paperId) {
                                            return {
                                              ...item,
                                              authors: update_authors,
                                            };
                                          } else {
                                            return item;
                                          }
                                        });
                                        setCitations(updated_citations);
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <img
                                      src="/delete.svg"
                                      onClick={async () => {
                                        const updated_citations = citations.map((item) => {
                                          if (item.paperId === selectedCitation.paperId) {
                                            let update_authors = item.authors.filter(
                                              (_, authorIndex) => authorIndex !== index
                                            );
                                            return {
                                              ...item,
                                              authors: update_authors,
                                            };
                                          } else {
                                            return item;
                                          }
                                        });

                                        setCitations(updated_citations);
                                      }}
                                      style={{ cursor: 'pointer' }}
                                      alt="delete"
                                      width={24}
                                      height={24}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label
                      className="label-style-wt-mb"
                      style={{
                        marginBottom: 0,
                        paddingBottom: 0,
                        fontSize: '14px',
                      }}
                    >
                      Add Another Author
                      <span>
                        <FontAwesomeIcon
                          icon={faCirclePlus}
                          color={theme.palette.primary.main}
                          style={{
                            marginLeft: 5,
                            cursor: 'pointer',
                          }}
                          onClick={async () => {
                            const updated_citations = citations.map((item) => {
                              if (item.paperId === selectedCitation.paperId) {
                                let update_authors = [
                                  ...item.authors,
                                  {
                                    authorId: generateId(),
                                    name: '',
                                    external_link: '',
                                  },
                                ];

                                return {
                                  ...item,
                                  authors: update_authors,
                                };
                              } else {
                                return item;
                              }
                            });
                            setCitations(updated_citations);
                          }}
                        ></FontAwesomeIcon>
                      </span>
                    </label>
                  </div>

                  <label className="label-style">Publication Date</label>
                  <input
                    type="date"
                    className="input-style"
                    value={citation?.publicationDate}
                    onChange={async (e) => {
                      const updated_citations = citations.map((item) => {
                        if (item.paperId === selectedCitation.paperId) {
                          return {
                            ...item,
                            publicationDate: e.target.value,
                          };
                        } else {
                          return item;
                        }
                      });
                      setCitations(updated_citations);
                    }}
                  />

                  <label className="label-style">Journal</label>
                  <input
                    type="text"
                    className="input-style"
                    value={citation?.venue}
                    onChange={async (e) => {
                      const updated_citations = citations.map((item) => {
                        if (item.paperId === selectedCitation.paperId) {
                          return {
                            ...item,
                            venue: e.target.value,
                          };
                        } else {
                          return item;
                        }
                      });
                      setCitations(updated_citations);
                    }}
                  />

                  <label className="label-style">DOI Number</label>
                  <input
                    type="text"
                    className="input-style"
                    value={citation?.doi}
                    onChange={async (e) => {
                      const updated_citations = citations.map((item) => {
                        if (item.paperId === selectedCitation.paperId) {
                          return {
                            ...item,
                            doi: e.target.value,
                          };
                        } else {
                          return item;
                        }
                      });
                      setCitations(updated_citations);
                    }}
                  />

                  <label className="label-style">Paper URL</label>
                  <input
                    type="text"
                    className="input-style"
                    value={citation?.url}
                    pattern={validateUrl}
                    title={invalidUrlError}
                    onChange={async (e) => {
                      const updated_citations = citations.map((item) => {
                        if (item.paperId === selectedCitation.paperId) {
                          return {
                            ...item,
                            url: e.target.value,
                          };
                        } else {
                          return item;
                        }
                      });
                      setCitations(updated_citations);
                    }}
                  />

                  {/* <Button
                    type="button"
                    variant="outlined"
                    disableRipple={true}
                    sx={buttonStyle}
                    onClick={onSubmitForm}
                  >
                    Save changes
                  </Button> */}
                </div>
              )}
            </>
          </div>
        ))}

        <div style={{ width: '96%', marginLeft: '0.8rem', marginTop: '1.5rem' }}>
          {show && (
            <div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <label className="label-style">Title </label>
              </div>

              <input
                type="text"
                className="input-style"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  set_current_citation({
                    ...current_citation,
                    title: e.target.value,
                  });
                }}
              />

              <div
                style={{
                  width: '100%',
                  marginTop: '10px',
                  marginBottom: '10px',
                }}
              >
                {authors.length > 0 && (
                  <div>
                    {authors.map((data, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4,
                          }}
                        >
                          <div style={{ width: '45%' }}>
                            <label className="label-style">Author Name</label>
                            <input
                              type="text"
                              className="input-style"
                              value={data.name}
                              onChange={async (event) => {
                                const value = event.target.value;
                                const update_authors = authors.map((item) => {
                                  if (item.authorId === data.authorId) {
                                    return {
                                      ...item,
                                      name: value,
                                    };
                                  } else {
                                    return item;
                                  }
                                });
                                setAuthors(update_authors);
                                set_current_citation({
                                  ...current_citation,
                                  authors: update_authors,
                                });
                              }}
                            />
                          </div>

                          <div style={{ width: '55%' }}>
                            <label className="label-style">Author URL:</label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{ width: '100%' }}>
                                <input
                                  type="text"
                                  className="input-style"
                                  placeholder="External Link"
                                  value={data.external_link}
                                  onChange={async (event) => {
                                    const value = event.target.value;
                                    const update_authors = authors.map((item) => {
                                      if (item.authorId === data.authorId) {
                                        return {
                                          ...item,
                                          external_link: value,
                                        };
                                      } else {
                                        return item;
                                      }
                                    });
                                    setAuthors(update_authors);
                                    set_current_citation({
                                      ...current_citation,
                                      authors: update_authors,
                                    });
                                  }}
                                />
                              </div>
                              <div>
                                <img
                                  src="/delete.svg"
                                  onClick={() => {
                                    const update_authors = authors.filter(
                                      (_, authorIndex) => authorIndex !== index
                                    );
                                    setAuthors(update_authors);
                                    set_current_citation({
                                      ...current_citation,
                                      authors: update_authors,
                                    });
                                  }}
                                  style={{ cursor: 'pointer' }}
                                  alt="delete"
                                  width={24}
                                  height={24}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label
                  className="label-style-wt-mb"
                  style={{
                    marginBottom: 0,
                    paddingBottom: 0,
                    fontSize: '14px',
                  }}
                >
                  <span>Add Another Author</span>
                  <span>
                    <FontAwesomeIcon
                      icon={faCirclePlus}
                      color={theme.palette.primary.main}
                      style={{
                        marginLeft: 5,
                        cursor: 'pointer',
                        fontSize: '15px',
                      }}
                      onClick={() => {
                        const update_authors = [
                          ...authors,
                          {
                            authorId: generateId(),
                            name: '',
                            external_link: '',
                          },
                        ];
                        setAuthors(update_authors);
                        set_current_citation({
                          ...current_citation,
                          authors: update_authors,
                        });
                      }}
                    ></FontAwesomeIcon>
                  </span>
                </label>
              </div>

              <label className="label-style">Publication Date</label>
              <input
                type="date"
                className="input-style"
                value={publicationDate}
                onChange={(e) => {
                  setPublicationDate(e.target.value);
                  set_current_citation({
                    ...current_citation,
                    publicationDate: publicationDate,
                  });
                }}
              />

              <label className="label-style">Journal</label>
              <input
                type="text"
                className="input-style"
                value={venue}
                onChange={(e) => {
                  setVenue(e.target.value);
                  set_current_citation({
                    ...current_citation,
                    venue: e.target.value,
                  });
                }}
              />

              <label className="label-style">DOI Number</label>
              <input
                type="text"
                className="input-style"
                value={doi}
                onChange={(e) => {
                  setDoi(e.target.value);
                  set_current_citation({
                    ...current_citation,
                    doi: e.target.value,
                  });
                }}
              />

              <label className="label-style">Paper URL</label>
              <input
                type="text"
                className="input-style"
                pattern={validateUrl}
                title={invalidUrlError}
                value={url}
                onChange={(e) => {
                  setURL(e.target.value);
                  set_current_citation({
                    ...current_citation,
                    url: e.target.value,
                  });
                }}
              />

              <div>
                <label
                  className="label-style-wt-mb"
                  style={{
                    marginBottom: 0,
                    paddingBottom: 0,
                    fontSize: '14px',
                  }}
                >
                  <span>
                    Add Another {category === 'citation' && 'Citation'}{' '}
                    {category === 'reference' && 'Reference'}
                  </span>
                  <span>
                    <FontAwesomeIcon
                      icon={faCirclePlus}
                      color={theme.palette.primary.main}
                      style={{
                        marginLeft: 5,
                        cursor: 'pointer',
                        fontSize: '15px',
                      }}
                      onClick={onSubmitForm}
                    ></FontAwesomeIcon>
                  </span>
                </label>
              </div>
            </div>
          )}

          {show === false && (
            <div style={{ marginBottom: '1rem' }}>
              <label
                className="label-style-wt-mb"
                style={{ marginBottom: 0, paddingBottom: 0, fontSize: '14px' }}
              >
                <span>
                  Add Another {category === 'citation' && 'Citation'}{' '}
                  {category === 'reference' && 'Reference'}
                </span>
                <span>
                  <FontAwesomeIcon
                    icon={faCirclePlus}
                    color={theme.palette.primary.main}
                    style={{
                      marginLeft: 5,
                      cursor: 'pointer',
                      fontSize: '15px',
                    }}
                    onClick={() => {
                      setSelectedCitation(null);
                      setShow(true);
                      if (formTopRef.current) {
                        formTopRef.current.scrollIntoView({
                          behavior: 'smooth',
                          block: 'start',
                        });
                      }
                    }}
                  ></FontAwesomeIcon>
                </span>
              </label>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CitationAndReferenceForm;
